import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
 :root {
  --white: #ffffff;
  --orange-50: #FFF7F1;
  --orange-300: #FFAF7E;
  --orange-500: #FF7022;
  --orange-600: #A03000;
  --orange-650: #E44D00;
  --orange-700: #A73600;
  --orange-900: #2C0D00;
  --marine-200: #0064C7;
  --marine-300: #003F7F;
  --marine-400: #001b38;
  --marine-500: #00162E;
  --marine-25:  #7AC1FF;
}

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: normal;
}

/* 4. Reset lists */
ul,
ol {
  list-style: none;
}

/* 5. Remove text decoration from links */
a {
  text-decoration: none;
  color: inherit;
}

/* 6. Reset buttons */
button {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
}

/* 7. Reset form elements */
input,
textarea,
select {
  background: none;
  border: none;
  outline: none;
  font: inherit;
  color: inherit;
}

textarea {
  resize: none;
}

/* 8. Remove default focus outlines, keep accessibility */
:focus {
  outline: none;
}

/* 9. Reset images and media */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 10. Make sure tables behave */
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/* 11. Remove default quotes in blockquotes */
blockquote,
q {
  quotes: none;
}

blockquote::before,
blockquote::after,
q::before,
q::after {
  content: '';
}

html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}

body {
  font-family: 'Montserrat', sans-serif;
  margin: 0;
  color: var(--white);
}

a {
  cursor: pointer;
  color: inherit;
}
`;
